import React, { Component } from 'react';
import { Button } from 'reactstrap';

class ControlCoupon extends Component {
    render() {

        return (
            <div className="ControlCoupon">
                <div className="Left-Control">
                    <Button color='primary'>Filter</Button>
                </div>

                <div className="Right-Control">
                    <Button color='primary' onClick={this.props.showModalNewCoupon}>New</Button> {' '}
                    <Button color='primary'>Export</Button>
                </div>
            </div>
        );
    }
}

export default ControlCoupon;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/coupon/CouponPage/components/ControlCoupon.js